import TelegramNotificationList from '../components/TelegramNotificationList.vue';

export default [
  {
    path: '',
    redirect: 'list',
    role: ['User']
  },
  {
    path: 'list',
    component: TelegramNotificationList,
    meta: {
      title: 'Telegram Notification',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/notification',
          title: 'Notification'
        },
        {
          path: 'list',
          title: 'Telegram Notification'
        }
      ]
    }
  }
];

